module.exports = __webpack_public_path__ + "images/emoji/sailboat.41cc6b89f409bd738ac2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sailboat.png
// module id = 2n93
// module chunks = 24